import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import useWindowWidth from '../../customHooks/useWindowWidth';

const ViewARTable = ({ sortedEmployeeAR, capitalizeFirstLetter }) => {

  const windowWidth = useWindowWidth();

  function renderTableRows(list) {
    // Group by date (acc[7] ? acc[7] : acc[4])
    const grouped = {};
    list
      .sort((a, b) => {
        const dateA = new Date(a[4]);
        const dateB = new Date(b[4]);
        return dateA - dateB;
      })
      .forEach((acc) => {
        const date = acc[7] ? acc[7] : acc[4];
        if (!grouped[date]) grouped[date] = [];
        grouped[date].push(acc);
      });

    // Render rows with rowSpan for date
    const rows = [];
    Object.entries(grouped).forEach(([date, accs]) => {
      accs.forEach((acc, idx) => {
        rows.push(
          <tr key={date + '-' + idx}>
            {idx === 0 && <td rowSpan={accs.length} className="date-cell">{date}</td>}
            <td>{acc[8] ? acc[8] : acc[5]}</td>
            <td className="sku-cell">{acc[0]}</td>
            <td>{acc[1]}</td>
          </tr>,
        );
      });
    });
    return rows;
  }

  const headers = [
    { key: 'date', label: 'Date',className: "date-cell" },
    { key: 'saleInvoice', label: 'Invoice' },
    { key: 'sku', label: 'SKU', className: 'sku-cell' },
    { key: 'name', label: windowWidth < 500 ? 'Accessory' : 'Accessory Name' },
    /* { key: 'quantity', label: 'Quantity' }, */
  ];
  return (
    <div className="tables thin-scrollbar">
      {sortedEmployeeAR?.map((detail, index) => (
        <div className="tables-container" key={index}>
          {detail.totalMsrpMinusDiscount.list1 !== 0 && (
            <div className="table thin-scrollbar">
              <div className="table-container" key={index}>
                <div className="emp">
                  <p>
                    <span>{capitalizeFirstLetter(detail.user)}:</span> Attached Accessories
                  </p>
                  <p>
                    <span>Revenue:</span> ${detail.totalMsrpMinusDiscount.list1.toFixed(2)}
                  </p>
                </div>
                <div className="table-acc" key={index}>
                  <table className="professional-table" key={index}>
                    <thead>
                      <tr>
                        {headers.map((header) => (
                          <Tooltip key={header.key} title={`${header.label}`} arrow placement="top">
                            <th className={header.className}>{header.label}</th>
                          </Tooltip>
                        ))}
                      </tr>
                    </thead>
                    <tbody>{renderTableRows(detail.attachedAcc.list1)}</tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          {detail.totalMsrpMinusDiscount.list2 !== 0 && (
            <div className="table thin-scrollbar">
              <div className="table-container">
                <div className="emp">
                  <p>
                    <span>{capitalizeFirstLetter(detail.user)}: </span> Only Accessories
                  </p>
                  <p>
                    <span>Revenue: </span>${detail.totalMsrpMinusDiscount?.list2?.toFixed(2)}
                  </p>
                </div>
                <div className="table-acc">
                  <table className="professional-table">
                    <thead>
                      <tr>
                        {headers.map((header, idx) => (
                          <Tooltip key={idx} title={`${header.label}`} arrow placement="top">
                            <th className={header.className}>{header.label}</th>
                          </Tooltip>
                        ))}
                      </tr>
                    </thead>
                    <tbody>{renderTableRows(detail.attachedAcc.list2)}</tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ViewARTable;
